import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ICategories } from './../../../../private/shared/models/productos';
import { IonSegment } from '@ionic/angular';

@Component({
  selector: 'getm-category-item',
  templateUrl: './category-item.component.html',
  styleUrls: ['./category-item.component.scss']
})
export class CategoryItemComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(IonSegment, { read: ElementRef }) segment!: ElementRef;
  
  @Input() categorias: ICategories[] = [];
  @Input() selected: string | null = null;

  @Output() selectCategory = new EventEmitter<string|null>();

  public isDesktop: boolean = false;

  // Mouse drag state
  private isDown = false;
  private startX = 0;
  private scrollLeft = 0;


  constructor() { }

  ngOnInit() {
    this.isDesktop = !Capacitor.isNativePlatform();
  }

  ngAfterViewInit(): void {
    if (!this.isDesktop) return;

    //solo en Desktop, simular swipe con click y arrastrar y ocultar el scroll
    const segmentElement = this.segment.nativeElement;
    segmentElement.addEventListener('mousedown', this.onMouseDown);

    segmentElement.addEventListener('mouseleave', this.onMouseLeave);

    segmentElement.addEventListener('mouseup', this.onMouseUp);

    segmentElement.addEventListener('mousemove', this.onMouseMove);
  }

  ngOnDestroy(): void {
    const segmentElement = this.segment.nativeElement;
    if (segmentElement) {
      segmentElement.removeEventListener('mousedown', this.onMouseDown);
      segmentElement.removeEventListener('mouseleave', this.onMouseLeave);
      segmentElement.removeEventListener('mouseup', this.onMouseUp);
      segmentElement.removeEventListener('mousemove', this.onMouseMove);
    }
  }

  public onCategoryClick = (id: string): void => {
    if(this.selected===id){
      this.selected = null;
      setTimeout(() => {
        this.segment.nativeElement.value = "";
      });
    }else{
      this.selected = id;
      this.segment.nativeElement.value = id;
    }
    this.selectCategory.emit(this.selected);
  };

  public trackByCats = (_index: number, item: ICategories): string => item.ID_Categoria_GETM;

  //event listeners

  private onMouseDown = (e: MouseEvent) => {
    const segmentElement = this.segment.nativeElement;
    this.isDown = true;
    this.startX = e.pageX - segmentElement.offsetLeft;
    this.scrollLeft = segmentElement.scrollLeft;
    segmentElement.style.cursor = 'grabbing';
  }

  private onMouseLeave = () => {
    this.isDown = false;
    const segmentElement = this.segment.nativeElement;
    segmentElement.style.cursor = 'grab';
  }

  private onMouseUp = () => {
    this.isDown = false;
    const segmentElement = this.segment.nativeElement;
    segmentElement.style.cursor = 'grab';
  }

  private onMouseMove = (e: MouseEvent) => {
    const segmentElement = this.segment.nativeElement;
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - segmentElement.offsetLeft;
    const walk = (x - this.startX) * 1.5; // adjust sensitivity
    segmentElement.scrollLeft = this.scrollLeft - walk;
  }
}
